// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4344":"css/app.6797","6986":"css/admin-app.6797"}[chunkId] + ".css";
};